/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CozWebIndicatorUpsertRequest = {
    bootCampCategory?: CozWebIndicatorUpsertRequest.bootCampCategory;
    name?: string;
    value?: string;
    unit?: string;
    caption?: string;
    description?: string;
    id?: number;
};

export namespace CozWebIndicatorUpsertRequest {

    export enum bootCampCategory {
        ALL = 'ALL',
        SEBFE = 'SEBFE',
        SEBBE = 'SEBBE',
        UUB = 'UUB',
        GMB = 'GMB',
        DOB = 'DOB',
        PMB = 'PMB',
        BEB = 'BEB',
        AIB = 'AIB',
    }


}

